import React from 'react';

const ProductBasicInfo = ({ formData, handleInputChange, categories = [] }) => {
  return (
    <div className="form-section">
      <h3>Basic Information</h3>
      <div className="form-row">
        <div className="form-group">
          <label>Product Name *</label>
          <input
            type="text"
            name="name"
            value={formData.name || ''}
            onChange={handleInputChange}
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label>Category *</label>
          <select
            name="category"
            value={formData.category || ''}
            onChange={handleInputChange}
            className="form-control"
          >
            <option value="">Select a category</option>
            {categories.map(cat => (
              <option key={cat.value} value={cat.value}>{cat.label}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label>Short Description</label>
          <textarea
            name="shortDescription"
            value={formData.shortDescription || ''}
            onChange={handleInputChange}
            className="form-control"
            rows="2"
          />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label>Description</label>
          <textarea
            name="description"
            value={formData.description || ''}
            onChange={handleInputChange}
            className="form-control"
            rows="4"
          />
        </div>
      </div>
    </div>
  );
};

export default ProductBasicInfo;
